var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 18V33H6.5V18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10.5H11.75C10.7554 10.5 9.80161 10.1049 9.09835 9.40165C8.39509 8.69839 8 7.74456 8 6.75C8 5.75544 8.39509 4.80161 9.09835 4.09835C9.80161 3.39509 10.7554 3 11.75 3C17 3 18.5 10.5 18.5 10.5Z",
    stroke: "#FFCC33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10.5H25.25C26.2446 10.5 27.1984 10.1049 27.9016 9.40165C28.6049 8.69839 29 7.74456 29 6.75C29 5.75544 28.6049 4.80161 27.9016 4.09835C27.1984 3.39509 26.2446 3 25.25 3C20 3 18.5 10.5 18.5 10.5Z",
    stroke: "#FFCC33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5H33.5V18H3.5V10.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 33.0001V8.88037",
    stroke: "#FFCC33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.abb96480942299398851d91e0c4eb03a.svg";
export { ForwardRef as ReactComponent };